var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Button, ButtonVariant, Content, Divider, Flex, FlexItem, PageBreadcrumb, PageSection, Split, SplitItem, } from '@patternfly/react-core';
import { ExternalLinkAltIcon } from '@patternfly/react-icons';
import { createUseStyles } from 'react-jss';
const useStyles = createUseStyles({
    iconMinWidth: {
        minWidth: '48px',
    }
});
export const PageHeader = ({ title, subtitle, linkProps, icon, label, breadcrumbs = null, actionMenu, ouiaId = 'PageHeader', children = null, headingClassname = subtitle ? 'pf-v6-u-mb-sm' : '' }) => {
    const classes = useStyles();
    const _a = linkProps !== null && linkProps !== void 0 ? linkProps : {}, { isExternal = false } = _a, linkRestProps = __rest(_a, ["isExternal"]);
    const showSplitRow = title || label || actionMenu;
    const showMainFlex = showSplitRow || subtitle || linkProps;
    return (React.createElement(React.Fragment, null,
        breadcrumbs && (React.createElement(PageBreadcrumb, null, breadcrumbs)),
        React.createElement(PageSection, { hasBodyWrapper: false },
            (showMainFlex || icon) &&
                React.createElement(Flex, null,
                    icon && (React.createElement(React.Fragment, null,
                        React.createElement(FlexItem, { alignSelf: { default: 'alignSelfCenter' }, className: classes.iconMinWidth }, icon),
                        React.createElement(Divider, { orientation: {
                                default: 'vertical',
                            } }))),
                    (showMainFlex) && (React.createElement(FlexItem, { flex: { default: 'flex_1' } },
                        (showSplitRow) && (React.createElement(Split, { hasGutter: true },
                            title && (React.createElement(SplitItem, null,
                                React.createElement(Content, { className: headingClassname, component: "h1", ouiaId: `${ouiaId}-title` }, title))),
                            label && (React.createElement(SplitItem, null, label)),
                            React.createElement(SplitItem, { isFilled: true }),
                            actionMenu && (React.createElement(SplitItem, null, actionMenu)))),
                        subtitle && (React.createElement(Content, { component: "p", ouiaId: `${ouiaId}-subtitle` }, subtitle)),
                        linkProps && (React.createElement(Button, Object.assign({ variant: ButtonVariant.link, component: "a", ouiaId: `${ouiaId}-link-button`, isInline: true, icon: isExternal ? React.createElement(ExternalLinkAltIcon, { className: 'pf-v6-u-ml-sm' }) : null, iconPosition: "end" }, linkRestProps), linkProps.label))))),
            children)));
};
export default PageHeader;
